import React, { useState,useEffect } from 'react';
import { Button, Card, CardBody, Col, Container, Row,Spinner} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb.js";
import { BasicTable } from './datatableCom.js';
import { Link } from 'react-router-dom';
import classnames from "classnames";
import axios from "axios";
import { BACKEND_URL_PORTAIL, BACKEND_Externe_URL} from "../../../config/const.js";
import { useTranslation } from 'react-i18next';
import MultiDeleteDialog from './MultiDeleteDialog';
import "./Styles.css";
const ListGroup = () => {
   
    const [customActiveTab, setcustomActiveTab] = useState("1");
    const [searchTerm, setSearchTerm] = useState('');
    const [groups,setGroups] = useState([]);
    const [admin,setAdmin] = useState(false);
    const [BceAdmin,setBceAdmin]= useState(false);
    const [loading, setLoading] = useState(true);
    const [selectedGroupIds, setSelectedGroupIds] = useState([]);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const {t} = useTranslation();
    document.title=  t('groupsManagement') +" | " +t('quessCompounding')
    const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      const handleOpenDialog = () => {
        setIsDialogOpen(true);
      };
    
      const handleCloseDialog = () => {
        setIsDialogOpen(false);
      };
    /*   const fetchGroups = async () => {
        const data={
            currentOrg:localStorage.getItem("currentOrg")
        }
      try {
        const response = await axios.post(`${BACKEND_URL_PORTAIL}api/user/isAdmin`,data,  config);
       switch (response) {
        case "BCEAdmin":
        setBceAdmin(true)
        break;
        case "Admin": 
          setAdmin(true)
        break;
       }
       const groupsData = await axios.get(`${BACKEND_URL}api/clients`,  config);
       setGroups(groupsData)
      } catch (error) {
        console.error("Error fetching profile data:", error.response ? error.response : error.message);
      
      }
    }; */

     const fetchGroups = async () => {
        setGroups([])
        const data={
            currentOrg:localStorage.getItem("currentOrg")
        }
          try {
            const response = await axios.post(`${BACKEND_URL_PORTAIL}api/isAdmin`,data,  config);
           switch (response) {
            case "BCEAdmin":
                setBceAdmin(true);
                var responseUsers = await axios.get(`${BACKEND_URL_PORTAIL}api/getAllGroups`,  config);
                console.log(responseUsers)
                setGroups(responseUsers);
            break;
            case "admin":
                setAdmin(true);
                var responseUsers = await axios.get(`${BACKEND_URL_PORTAIL}api/connectedUserOrganisations`,  config);
                console.log(responseUsers)
                setGroups(responseUsers)
            break;
           }
            
         
          } catch (error) {
            console.error("Error fetching profile data:", error.response ? error.response : error.message);
          
          }finally {
            setLoading(false); 
        }
        };
    useEffect(() => {
     
        fetchGroups();
      }, []); 

    
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Card className="card-bordred custom-card">
<Breadcrumbs title={t('groupsManagement')} breadcrumbItem={t('listOfGroups')} />

                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <div id="customerList">
                                        <Row className="g-4 mb-3">
                                            <Col className="col-sm-auto">
                                               {BceAdmin &&(<div className="d-flex gap-2">
                                                    <Button color="primary" tag={Link} to="/create-group">
                                                        <i className="ri-add-line align-bottom me-1"></i>{t('createGroup')}
                                                    </Button>

                                                    {selectedGroupIds.length === groups.length ? (
                                                        <Button color="primary" onClick={() => setSelectedGroupIds([])}>
                                                            {t('allDeselect')}
                                                        </Button>
                                                        ) : (
                                                        <Button color="primary" onClick={() => setSelectedGroupIds(groups.map(g => g.id))}>
                                                            {t('allSelect')}
                                                        </Button>
                                                        )}

                                                    <Button color="danger" onClick={handleOpenDialog} disabled={selectedGroupIds.length === 0} >
                                                        {t('delete')}
                                                    </Button>
                                                </div>)} 
                                            </Col>
                                            <Col className="col-sm">
                                                <div className="d-flex justify-content-sm-end">
                                                    <div className="search-box">
                                                        <input
                                                            type="text"
                                                            className="form-control search"
                                                            placeholder={t('search')}
                                                            value={searchTerm}
                                                            onChange={e => setSearchTerm(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>

                                        <Col lg={12}>
                                          
                                        {loading ? ( 
                                                <div className="text-center mt-6">
                                                            <Spinner
                                                           color="primary"
                                                           style={{
                                                             height: '3rem',
                                                             width: '3rem'
                                                           }}
                                                         >
                                                           Loading...
                                                            </Spinner>
                                                            <div className="text-center mt-2">
                                                          {t("loading...")}
                                                          </div>
                                                          </div>
                                            ) : (
                                                    <Row>
                                                  
                                                        <Col sm="12">
                                                        <div >
                                                            <BasicTable searchTerm={searchTerm} 
                                                            initialData={groups} 
                                                            isBce={BceAdmin} 
                                                            fetchGroups={fetchGroups} 
                                                            onSelectionChange={setSelectedGroupIds} 
                                                            selectedGroupIds={selectedGroupIds}/>
                                                        </div>
                                                        </Col>
                                                    </Row>
                                              
                                            )} 
                                       
                                        </Col>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    </Card>
                    
                </Container>
                {isDialogOpen && (
                        <MultiDeleteDialog
                        isOpen={isDialogOpen}
                        handleClose={handleCloseDialog}
                        listGroups={selectedGroupIds} // Pass groupId to the dialog
                        fetchGroups={fetchGroups}
                        />
                    )}
            </div>
        </React.Fragment>
    );
};

export default ListGroup;
